!function($) {

  // Add custom JavsScript here
  // --------------------------

  // Document ready
  $(function() {
    
	$('body.cart #update-cart').on('click', function(e) {
      $('#datepicker').removeAttr('required').removeClass('required');
    });
	
	$('#aisleButton').show();

	$('#aisleButton').on('click', function() {
// 	  var e = $('#aisleMenu');
// 	  var s = $('#site-body');
// 	  if (e.css('display') == 'none') {
// 		  e.css('display', 'block');
// 		  s.css('display', 'none')
// 	  }
// 	  else {
// 		  e.css('display', 'none');
// 		  s.css('display', 'block')
// 	  } 
	});

  });

}(jQuery);